// We only need to import the modules necessary for initial render
import PublicLayout from "layouts/PublicLayout";
import CoreLayout from "layouts/CoreLayout";
import LoginRoute from "./Login";
import HomeRoute from "./Home";
import ReportsRoute from "./Reports";
import AlertsRoute from "./Alerts";
import ActionPlansRoute from "./ActionPlans";
import SocialRoute from "./SocialListening";
import CocreationRoute from "./Cocreation";
import Users from "./Users";

/*  Note: We use react-router PlainRoute object to build route definitions */

export const createRoutes = store => [
  {
    path: '/auth',
    component: PublicLayout,
    indexRoute: LoginRoute(store),
    childRoutes: [LoginRoute(store)]
  },
  {
    path: '/',

    component: CoreLayout,

    indexRoute: HomeRoute(),

    onEnter: (nextState, transition) => {
      const { auth, user } = store.getState();

      if (!auth.token) {
        const regex = /(alerts)\/(\S+)/gim;
        if (nextState.location.pathname.match(regex)) {
          transition({
            pathname: '/auth',
            state: {
              next: nextState.location.pathname
            }
          });
        } else {

          transition({
            pathname: '/auth'
          });
        }
        return;
      }
    },

    childRoutes: [
      ReportsRoute(),
      AlertsRoute(),
      Users(store),
      ActionPlansRoute(),
      SocialRoute(),
      CocreationRoute()
    ]
  }
];

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.js